import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { IPipelineMast } from "../../models/PipelineMast";

interface IProps {
    hideQueryDialog: () => void,
    open: boolean,
    toast: any,
    submission_ID: number,
    row: IPipelineMast,
    loadTableData: () => void,
}

export const AcceptRejectRejectionModal = (props: IProps) => {
    const [comment, setComment] = useState("");
    const [loading, setLoading] = useState(false);

    const acceptRejectRejectionStatus = async (sub_id?: number, status?: boolean) => {
        if (!sub_id) {
            props.toast.current.show({ severity: 'error', detail: "Not Valid Submission", life: 3000 });
        } else if (comment === null || comment.trim() === "") {
            props.toast.current.show({ severity: 'error', detail: `Please give a comment for ${status ? 'accepting' : 'not accepting'}`, life: 3000 });
        } else {
            setLoading(true);
            const response = await Fetch("Pipeline_Mast/recruiteracknowledgement", "POST", {
                Sub_ID: sub_id,
                acknowledgement: comment,
                isAccepted: status,
            }, null, props.toast);

            if (response) {
                props.toast.current.show({ severity: 'success', detail: "Done Acknowledgement", life: 3000 });
                setLoading(false);
                const data: any = await response.json();
                props.loadTableData();
                props.hideQueryDialog();
                setComment("");
            } else setLoading(false);
        }
    };

    return (
        <>
            <Dialog visible={props.open} style={{ width: '60vw' }} header={`Accept/Reject Submission Rejection ${props.submission_ID} ?`} className="p-fluid" draggable={false} onHide={() => { props.hideQueryDialog(); setComment(""); }}>
                <div className="mb-3">
                    <p className="flex gap-3"><span style={{ width: '10rem' }}>Rejection Status :</span><span style={{ width: '80%' }}>{props.row?.status_Name}</span></p>
                    <p className="flex gap-3"><span style={{ width: '10rem' }}>Rejection Sub Status :</span><span style={{ width: '80%' }}>{props.row?.rejection_Status}</span></p>
                    <p className="flex gap-3"><span style={{ width: '10rem' }}>Rejection Comment :</span><span style={{ width: '80%' }}>{props.row?.comments}</span></p>
                </div>
                <InputTextarea name="query" placeholder="write your acknowledgement here..." value={comment} onChange={(e) => setComment(e.target.value)} rows={5} cols={30} maxLength={500} autoResize />
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
                    <Button loading={loading} className="p-button-sm my-1" label="ACCEPT" type="button" onClick={() => acceptRejectRejectionStatus(props?.submission_ID, true)}></Button>
                    <Button loading={loading} className="button-sm my-1" style={{ borderColor: 'red', backgroundColor: 'red' }} label="REJECT" type="button" onClick={() => acceptRejectRejectionStatus(props?.submission_ID, false)}></Button>
                    <Button loading={loading} className="p-button-sm p-button-outlined my-1" label="CLOSE" onClick={() => { props.hideQueryDialog(); setComment(""); }} type="button"></Button>
                </div>
            </Dialog>
        </>
    );
}